import React, { useState } from "react";

import {
  Question,
  QuestionWrapper,
  Answer,
  ShowMoreLessButton,
  AnswerWrapper,
} from "./style";

function QuestionItem({ question, answer }) {
  const [height, setHeight] = useState(0);
  const [showMore, setShowMore] = useState(false);

  const setCardHeight = (node) => {
    const _height = node?.getBoundingClientRect()?.height;
    if (_height) setHeight(node?.getBoundingClientRect()?.height);
  };

  return (
    <div>
      <QuestionWrapper>
        <Question variant="heading6">* {question}</Question>
        <AnswerWrapper style={{ maxHeight: showMore ? "unset" : "72px" }}>
          <Answer
            dangerouslySetInnerHTML={{ __html: answer }}
            ref={setCardHeight}
          />
        </AnswerWrapper>
        {height > 72 && (
          <ShowMoreLessButton
            variant="link"
            onClick={() => setShowMore((prevState) => !prevState)}
          >
            {showMore ? "Show Less" : "Show More"}
          </ShowMoreLessButton>
        )}
      </QuestionWrapper>
    </div>
  );
}

export default QuestionItem;
